import { createI18n } from "vue-i18n";

const messages = {
  1: {
    displayValue_Respondent: {
      // ログイン
      LOGIN_ttl_doc: "ログイン",
      LOGIN_ttl_screen: "ログイン",
      LOGIN_ttl_header: "ストレスチェック受診者ログインページ",
      LOGIN_lbl_com_id: "企業ID",
      LOGIN_lbl_emp_id: "社員ID",
      LOGIN_lbl_pw: "パスワード",
      LOGIN_btn_login: "ログイン",
      LOGIN_msg_failure_login: "IDまたはパスワードが違います",
      LOGIN_guide_set_language: "言語選択",

      // ヘッダー
      HEADER_user_suffix: "様",
      HEADER_guide_change_pw: "パスワード変更",

      // パスワード変更
      CHANGE_PW_ttl_doc: "パスワード変更",
      CHANGE_PW_ttl_screen: "パスワード変更",
      CHANGE_PW_lbl_pw_now: "現在のパスワード",
      CHANGE_PW_lbl_pw_new: "新しいパスワード",
      CHANGE_PW_guide_num_of_char: "（パスワードは4文字以上必要です）",
      CHANGE_PW_lbl_pw_new_re: "新しいパスワード(確認用)",
      CHANGE_PW_guide_pw_switch: "パスワードを表示する",
      CHANGE_PW_btn_back: "戻る",
      CHANGE_PW_btn_update: "更新",
      CHANGE_PW_msg_no_match_pw: "パスワード(確認用)が異なります",
      CHANGE_PW_alert_changed_pw: "パスワードの変更が完了しました",
      CHANGE_PW_msg_changed_pw: "パスワードを変更しました",
      CHANGE_PW_msg_failure_change_pw: "パスワードの変更に失敗しました",

      // ホーム
      HOME_ttl_doc: "ストレスチェック",
      HOME_guide_questionnaire: "アンケート",
      HOME_btn_preparation: "準備中",
      HOME_btn_progress: "実施中",
      HOME_btn_result: "診断結果",
      HOME_guide_about_service: "ストレスチェックとは",
      HOME_guide_description_service1:
        "実施期間終了後に、アンケートの回答結果を分析します。",
      HOME_guide_description_service2:
        "分析終了後結果確認ページよりご確認ください。",
      HOME_guide_description_service3:
        "※結果は一部日本語のみの表記になります。",

      // 準備中
      PREPARATION_ttl_doc: "回答ページ",
      PREPARATION_guide_preparation_service: "ストレスチェック実施予定",
      PREPARATION_guide_no_preparation: "現在実施予定のものはありません",
      PREPARATION_preparation_ym: "__replace1__年__replace2__月 実施予定",
      PREPARATION_guide_sc_period: "実施期間",
      PREPARATION_sc_period:
        "__replace1__年__replace2__月__replace3__日(__replace4__) ～ __replace5__年__replace6__月__replace7__日(__replace8__)",
      PREPARATION_guide_answer_format: "回答形式",
      PREPARATION_answer_format: "Web回答",
      PREPARATION_guide_description_answer_format:
        "実施期間中にストレスチェックシステムへログインし、回答ページよりアンケートにご回答ください。",
      PREPARATION_guide_notice_format: "結果通知形式",
      PREPARATION_notice_format_paper: "ストレスプロフィール",
      PREPARATION_notice_format_web: "Web通知",
      PREPARATION_guide_description_notice_format_paper:
        "実施期間終了後に、アンケートの回答結果を分析し、インテリジェントヘルスケア株式会社が作成するストレスチェック分析結果用紙をお送りします。",
      PREPARATION_guide_description_notice_format_web:
        "実施期間終了後に、アンケートの回答結果を分析します。分析終了後結果確認ページよりご確認ください。",

      // 実施中
      PREPARATION_btn_back: "戻る",
      PROGRESS_ttl_doc: "回答ページ",
      PROGRESS_guide_service: "ストレスチェック",
      PROGRESS_guide_no_progress: "実施中のものはありません",
      PROGRESS_progress_ym: "__replace1__年__replace2__月",
      PROGRESS_guide_progress_service: "ストレスチェック実施中",
      PROGRESS_guide_sc_end_date: "アンケート終了日",
      PROGRESS_sc_end_date:
        "__replace1__年__replace2__月__replace3__日(__replace4__)",
      PROGRESS_guide_submission_date: "回答提出日",
      PROGRESS_no_submitted: "未提出",
      PROGRESS_submitted: "提出済み",
      PROGRESS_submission_date:
        "__replace1__年__replace2__月__replace3__日(__replace4__)",
      PROGRESS_guide_questionnaire: "アンケート",
      PROGRESS_guide_description_howto_answer1: "質問は全57問あります。",
      PROGRESS_guide_description_howto_answer2:
        "回答は途中保存されます。実施期間内に全ての質問にお答えください。",
      PROGRESS_guide_description_howto_answer3:
        "全ての質問にお答えいただけない場合、正確な分析結果が得られない可能性があります。",
      PROGRESS_guide_description_howto_answer4:
        "ブラウザの戻るボタンは使用しないでください。",
      PROGRESS_btn_answer: "回答する",
      PROGRESS_btn_confirm_answer: "回答確認",
      PROGRESS_btn_back: "戻る",

      // 回答
      ANSWER_guide_description_answer_head:
        "最も当てはまるものを選択してください",
      ANSWER_guide_current_answer_prefix: "問",
      ANSWER_btn_previous: "前の質問",

      // 回答提出
      SUBMIT_guide_all_answered: "全__replace1__問回答済み",
      SUBMIT_guide_already_submit: "回答提出済み",
      SUBMIT_guide_no_submitted: "回答未提出",
      SUBMIT_btn_submit_answer: "回答を提出する",
      SUBMIT_guide_no_submitted_case1: "をクリックするまで",
      SUBMIT_guide_no_submitted_case2: "未回答扱い",
      SUBMIT_guide_no_submitted_case3: "となります。",
      SUBMIT_msg_answer_submitted: "回答が送信されました",
      SUBMIT_guide_description_submitted1: "ご協力ありがとうございました。",
      SUBMIT_guide_description_submitted2:
        "ストレスチェックの結果は、アンケート回答期間終了後に結果確認ページにてご確認いただけます。",
      SUBMIT_guide_description_submitted3:
        "アンケートの分析完了までもうしばらくお待ちください。",
      SUBMIT_btn_go_home: "ホームへ",

      // 結果
      RESULT_ttl_doc: "ストレスチェック結果一覧",
      RESULT_ttl_screen: "ストレスチェック結果一覧",
      RESULT_result_ym: "__replace1__年__replace2__月分",
      RESULT_guide_no_result: "ストレスチェック受診歴はありません",
      RESULT_btn_back: "戻る",
      RESULT_msg_analysis_pdf1: "ただいま分析中です",
      RESULT_msg_analysis_pdf2: "時間をあけてご確認ください",
    },
  },
  2: {
    displayValue_Respondent: {
      // ログイン
      LOGIN_ttl_doc: "Login",
      LOGIN_ttl_screen: "Login",
      LOGIN_ttl_header: "Login Page for Stress Check Candidates",
      LOGIN_lbl_com_id: "Company ID",
      LOGIN_lbl_emp_id: "Employee ID",
      LOGIN_lbl_pw: "Password",
      LOGIN_btn_login: "Login",
      LOGIN_msg_failure_login: "Incorrect ID or password",
      LOGIN_guide_set_language: "Select language ",

      // ヘッダー
      HEADER_user_suffix: "",
      HEADER_guide_change_pw: "Change password",

      // パスワード変更
      CHANGE_PW_ttl_doc: "Change password",
      CHANGE_PW_ttl_screen: "Change password",
      CHANGE_PW_lbl_pw_now: "Current password",
      CHANGE_PW_lbl_pw_new: "New password",
      CHANGE_PW_guide_num_of_char:
        "(Password must be at least 4 characters long.)",
      CHANGE_PW_lbl_pw_new_re: "Confirm New password",
      CHANGE_PW_guide_pw_switch: "Show password",
      CHANGE_PW_btn_back: "Back",
      CHANGE_PW_btn_update: "Update",
      CHANGE_PW_msg_no_match_pw: "The password and confirmation do not match.",
      CHANGE_PW_alert_changed_pw:
        "Your password has been successfully changed.",
      CHANGE_PW_msg_changed_pw: "Password has been changed.",
      CHANGE_PW_msg_failure_change_pw: "Failed to change the password.",

      // ホーム
      HOME_ttl_doc: "Stress check",
      HOME_guide_questionnaire: "Questionnaire",
      HOME_btn_preparation: "In preparation",
      HOME_btn_progress: "In progress",
      HOME_btn_result: "Result",
      HOME_guide_about_service: "",
      HOME_guide_description_service1:
        "After the implementation period, the results of the survey responses will be analyzed.",
      HOME_guide_description_service2:
        "Please confirm the results from the Results Confirmation page after the analysis is completed.",
      HOME_guide_description_service3: "※Some results are in Japanese only.",

      // 準備中
      PREPARATION_ttl_doc: "Answer page",
      PREPARATION_guide_preparation_service: "Stress check schedule",
      PREPARATION_guide_no_preparation: "No scheduled activities at the moment",
      PREPARATION_preparation_ym: "Planned for __replace2__, __replace1__",
      PREPARATION_guide_sc_period: "Implementation period",
      PREPARATION_sc_period:
        "__replace1__, __replace2__ __replace3__, __replace4__ ～ __replace5__, __replace6__ __replace7__, __replace8__",
      PREPARATION_guide_answer_format: "Answer format",
      PREPARATION_answer_format: "Web answer",
      PREPARATION_guide_description_answer_format:
        "Please log in to the stress check system during the implementation period and answer the questionnaire on the response page.",
      PREPARATION_guide_notice_format: "Notification format",
      PREPARATION_notice_format_paper: "stress profile",
      PREPARATION_notice_format_web: "Web notification",
      PREPARATION_guide_description_notice_format_paper:
        "After the survey period ends, the survey responses will be analyzed and a stress check analysis results form created by Intelligent Healthcare Co., Ltd. will be sent to you.",
      PREPARATION_guide_description_notice_format_web:
        "After the survey period ends, we will analyze the survey results. Once the analysis is complete, please check the results on the results confirmation page.",
      PREPARATION_btn_back: "Back",

      // 実施中
      PROGRESS_ttl_doc: "Answer page",
      PROGRESS_guide_service: "Stress check",
      PROGRESS_guide_no_progress: "None in progress",
      PROGRESS_progress_ym: "__replace2__, __replace1__",
      PROGRESS_guide_progress_service: "Stress check in progress",
      PROGRESS_guide_sc_end_date: "Submission deadline",
      PROGRESS_sc_end_date:
        "__replace1__, __replace2__ __replace3__, __replace4__",
      PROGRESS_guide_submission_date: "Date of response",
      PROGRESS_no_submitted: "Not submitted",
      PROGRESS_submitted: "Submitted",
      PROGRESS_submission_date:
        "__replace1__, __replace2__ __replace3__, __replace4__",
      PROGRESS_guide_questionnaire: "Questionnaire",
      PROGRESS_guide_description_howto_answer1:
        "There are 57 questions in total.",
      PROGRESS_guide_description_howto_answer2:
        "Your answers will be saved during the process. Please answer all questions within the given period.",
      PROGRESS_guide_description_howto_answer3:
        "*If you cannot answer all the questions, we may not be able to obtain accurate analysis results.",
      PROGRESS_guide_description_howto_answer4:
        "*Please do not use the back button on your browser.",
      PROGRESS_btn_answer: "Answer",
      PROGRESS_btn_confirm_answer: "Confirm your answer",
      PROGRESS_btn_back: "Back",

      // 回答
      ANSWER_guide_description_answer_head:
        "Choose the answer that best applies",
      ANSWER_guide_current_answer_prefix: "Q",
      ANSWER_btn_previous: "Previous question",

      // 回答提出
      SUBMIT_guide_all_answered: "All __replace1__ questions answered",
      SUBMIT_guide_already_submit: "Answer submitted",
      SUBMIT_guide_no_submitted: "No response submitted",
      SUBMIT_btn_submit_answer: "Submit my answer",
      SUBMIT_guide_no_submitted_case1: "",
      SUBMIT_guide_no_submitted_case2: "",
      SUBMIT_guide_no_submitted_case3:
        'Your question will be treated as unanswered until you click on "Submit my answer"',
      SUBMIT_msg_answer_submitted: "Your answers have been submitted",
      SUBMIT_guide_description_submitted1: "Thank you for your cooperation.",
      SUBMIT_guide_description_submitted2:
        "The results of the stress test can be viewed on the results confirmation page after the survey response period ends.",
      SUBMIT_guide_description_submitted3:
        "Please wait a little while until we complete the analysis of your survey.",
      SUBMIT_btn_go_home: 'Go to "home"',

      // 結果
      RESULT_ttl_doc: "Stress check results list",
      RESULT_ttl_screen: "Stress check results list",
      RESULT_result_ym: "__replace2__ __replace1__ issue",
      RESULT_guide_no_result: "No history of stress check",
      RESULT_btn_back: "Back",
      RESULT_msg_analysis_pdf1: "Currently being analyzed",
      RESULT_msg_analysis_pdf2: "Please check again later.",
    },
  },
  3: {
    displayValue_Respondent: {
      // ログイン
      LOGIN_ttl_doc: "Đăng nhập",
      LOGIN_ttl_screen: "Đăng nhập",
      LOGIN_ttl_header: "Trang đăng nhập của người kiểm tra căng thẳng",
      LOGIN_lbl_com_id: "Mã ID công ty",
      LOGIN_lbl_emp_id: "Mã ID nhân viên",
      LOGIN_lbl_pw: "Mật khẩu",
      LOGIN_btn_login: "Đăng nhập",
      LOGIN_msg_failure_login: "ID hoặc mật khẩu không đúng",
      LOGIN_guide_set_language: "Lựa chọn ngôn ngữ",

      // ヘッダー
      HEADER_user_suffix: "",
      HEADER_guide_change_pw: "Thay đổi mật khẩu",

      // パスワード変更
      CHANGE_PW_ttl_doc: "Thay đổi mật khẩu",
      CHANGE_PW_ttl_screen: "Thay đổi mật khẩu",
      CHANGE_PW_lbl_pw_now: "Mật khẩu hiện tại",
      CHANGE_PW_lbl_pw_new: "Mật khẩu mới",
      CHANGE_PW_guide_num_of_char: "(Mật khẩu phải có ít nhất 4 ký tự)",
      CHANGE_PW_lbl_pw_new_re: "Xác nhận mật khẩu mới",
      CHANGE_PW_guide_pw_switch: "Hiển thị mật khẩu",
      CHANGE_PW_btn_back: "Trở lại",
      CHANGE_PW_btn_update: "Cập nhật",
      CHANGE_PW_msg_no_match_pw: "Mật khẩu không khớp.",
      CHANGE_PW_alert_changed_pw:
        "Mật khẩu của bạn đã được thay đổi thành công.",
      CHANGE_PW_msg_changed_pw: "Mật khẩu đã được thay đổi.",
      CHANGE_PW_msg_failure_change_pw: "Thay đổi mật khẩu thất bại.",

      // ホーム
      HOME_ttl_doc: "Kiểm tra căng thẳng",
      HOME_guide_questionnaire: "Bảng câu hỏi",
      HOME_btn_preparation: "Đang chuẩn bị",
      HOME_btn_progress: "Đang tiến hành",
      HOME_btn_result: "Chẩn đoán",
      HOME_guide_about_service: "",
      HOME_guide_description_service1:
        "Sau khi thời gian khảo sát kết thúc, kết quả khảo sát sẽ được phân tích.",
      HOME_guide_description_service2:
        "Sau khi phân tích hoàn tất, hãy kiểm tra kết quả trên trang xác nhận.",
      HOME_guide_description_service3:
        "*Một số kết quả chỉ hiển thị bằng tiếng Nhật.",

      // 準備中
      PREPARATION_ttl_doc: "Trang trả lời",
      PREPARATION_guide_preparation_service: "Lịch trình kiểm tra căng thẳng",
      PREPARATION_guide_no_preparation:
        "Hiện không có cuộc kiểm tra nào được lên kế hoạch.",
      PREPARATION_preparation_ym:
        "Dự kiến thực hiện vào tháng __replace2__ năm __replace1__",
      PREPARATION_guide_sc_period: "Thời gian thực hiện",
      PREPARATION_sc_period:
        "__replace1__, __replace2__/__replace3__/__replace4__ – __replace5__, __replace6__/__replace7__/__replace8__",
      PREPARATION_guide_answer_format: "Hình thức trả lời",
      PREPARATION_answer_format: "Trả lời trên web",
      PREPARATION_guide_description_answer_format:
        "Trong thời gian diễn ra khảo sát, xin vui lòng đăng nhập vào hệ thống kiểm tra stress và trả lời bảng câu hỏi từ trang trả lời.",
      PREPARATION_guide_notice_format: "Hình thức thông báo kết quả",
      PREPARATION_notice_format_paper: "Hồ sơ căng thẳng",
      PREPARATION_notice_format_web: "Thông báo Web",
      PREPARATION_guide_description_notice_format_paper:
        "Sau khi kết thúc thời gian thực hiện, Công ty TNHH Intelligent Healthcare sẽ phân tích kết quả khảo sát và gửi đến quý khách bản báo cáo kết quả phân tích kiểm tra căng thẳng.",
      PREPARATION_guide_description_notice_format_web:
        "Sau khi kết thúc thời gian thực hiện, chúng tôi sẽ tiến hành phân tích kết quả khảo sát. Sau khi hoàn tất phân tích, quý vị vui lòng truy cập trang xác nhận kết quả để kiểm tra.",
      PREPARATION_btn_back: "Trở lại",

      // 実施中
      PROGRESS_ttl_doc: "Trang trả lời",
      PROGRESS_guide_service: "Kiểm tra căng thẳng",
      PROGRESS_guide_no_progress: "Hiện không có nội dung đang thực hiện",
      PROGRESS_progress_ym: "tháng __replace2__ năm __replace1__",
      PROGRESS_guide_progress_service: "Đang tiến hành kiểm tra căng thẳng",
      PROGRESS_guide_sc_end_date: "Ngày kết thúc khảo sát",
      PROGRESS_sc_end_date:
        "__replace1__, __replace2__/__replace3__/__replace4__",
      PROGRESS_guide_submission_date: "Ngày nộp phản hồi",
      PROGRESS_no_submitted: "Chưa nộp",
      PROGRESS_submitted: "Đã nộp",
      PROGRESS_submission_date:
        "__replace1__, __replace2__/__replace3__/__replace4__",
      PROGRESS_guide_questionnaire: "Bảng câu hỏi",
      PROGRESS_guide_description_howto_answer1: "Tổng cộng có 57 câu hỏi.",
      PROGRESS_guide_description_howto_answer2:
        "Câu trả lời của bạn sẽ được lưu trong quá trình thực hiện. Vui lòng trả lời tất cả các câu hỏi trong thời gian cho phép.",
      PROGRESS_guide_description_howto_answer3:
        "Nếu không trả lời hết tất cả các câu hỏi, kết quả phân tích có thể không chính xác",
      PROGRESS_guide_description_howto_answer4:
        '*Vui lòng không sử dụng nút "quay lại" trên trình duyệt của bạn.',
      PROGRESS_btn_answer: "Trả lời",
      PROGRESS_btn_confirm_answer: "Xác nhận câu trả lời của bạn",
      PROGRESS_btn_back: "Trở lại",

      // 回答
      ANSWER_guide_description_answer_head: "Vui lòng chọn mục phù hợp nhất.",
      ANSWER_guide_current_answer_prefix: "Câu",
      ANSWER_btn_previous: "Câu hỏi trước",

      // 回答提出
      SUBMIT_guide_all_answered: "Đã trả lời xong __replace1__ câu hỏi",
      SUBMIT_guide_already_submit: "Đã nộp câu trả lời",
      SUBMIT_guide_no_submitted: "Chưa nộp bài",
      SUBMIT_btn_submit_answer: "Gửi câu trả lời",
      SUBMIT_guide_no_submitted_case1: "",
      SUBMIT_guide_no_submitted_case2: "",
      SUBMIT_guide_no_submitted_case3:
        "Cho đến khi bạn nhấn vào “Gửi câu trả lời”, câu trả lời của bạn sẽ được coi là chưa hoàn thành",

      SUBMIT_msg_answer_submitted: "Câu trả lời của bạn đã được gửi",
      SUBMIT_guide_description_submitted1: "Cảm ơn bạn đã hợp tác.",
      SUBMIT_guide_description_submitted2:
        "Kết quả của bài kiểm tra căng thẳng có thể được xem trên trang xác nhận kết quả sau khi thời gian phản hồi khảo sát kết thúc.",
      SUBMIT_guide_description_submitted3:
        "Vui lòng đợi một lát cho đến khi chúng tôi hoàn tất việc phân tích khảo sát của bạn.",
      SUBMIT_btn_go_home: "Về trang chủ",

      // 結果
      RESULT_ttl_doc: "Danh sách kết quả kiểm tra căng thẳng",
      RESULT_ttl_screen: "Danh sách kết quả kiểm tra căng thẳng",
      RESULT_result_ym: "Tháng __replace2__ năm __replace1__",
      RESULT_guide_no_result: "Không có lịch sử thử nghiệm căng thẳng",
      RESULT_btn_back: "Trở lại",
      RESULT_msg_analysis_pdf1: "Hiện đang được phân tích",
      RESULT_msg_analysis_pdf2: "Vui lòng kiểm tra lại sau.",
    },
  },
};

const i18n = createI18n({
  locale: "1", // デフォルトの言語（日本語）
  fallbackLocale: "2", // 言語が見つからない場合のフォールバック（英語）
  messages,
});

export default i18n;
